import { InvestorTransferNavSummaryTable } from "features/investor-transfer/setup/InvestorTransferNavSummaryTable";
import { InvestorTransferReviewDocumentsTable } from "features/investor-transfer/setup/InvestorTransferReviewDocumentsTable";
import {
  InvestorTransferReviewTransfereeEntitiesTable,
  InvestorTransferReviewTransferorEntityTable,
} from "features/investor-transfer/setup/InvestorTransferReviewEntityTable";
import {
  useInvestorTransferorsForInvestorTransferListSuspense,
  useInvestorTransferRetrieveSuspense,
} from "gen/endpoints/investor-transfer/investor-transfer";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";
import { formatIsoDateToDisplay } from "shared/utils/DateUtils";
import { formatMoney, sumMoneyStrings } from "shared/utils/MoneyUtils";

export const InvestorTransferViewPage: React.FC = () => {
  const { t } = useTranslation(["common", "investorTransfer"]);
  const { fundFamilyId, investorTransferId } = useRequiredStringParams();

  const { data: investorTransferData } = useInvestorTransferRetrieveSuspense(
    fundFamilyId,
    investorTransferId,
  );

  const { data: investorTransferorDataList } =
    useInvestorTransferorsForInvestorTransferListSuspense(
      fundFamilyId,
      investorTransferId,
    );

  return (
    <PageContent contentWidth="boxed">
      <PageHeader
        backButton={{
          title: t("investorTransfer:transfers"),
          path: rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .commitments({})
            .transfersTab({}).$,
        }}
        title={t("investorTransfer:view.title", {
          name: investorTransferorDataList[0].investor_legal_name,
        })}
        helperText={t("investorTransfer:setup.review.description", {
          investor_name: investorTransferorDataList[0].investor_legal_name,
          transfer_amount: formatMoney(
            sumMoneyStrings(
              investorTransferorDataList.map((it) => it.transfer_amount),
            ),
          ),
          fund_name: investorTransferorDataList[0].fund_name,
          transfer_date: formatIsoDateToDisplay(
            investorTransferData.recorded_date,
          ),
        })}
      />
      <PageBody>
        <InvestorTransferReviewTransferorEntityTable
          fundFamilyId={fundFamilyId}
          investorTransferId={investorTransferId}
        />
        <InvestorTransferReviewTransfereeEntitiesTable
          fundFamilyId={fundFamilyId}
          investorTransferId={investorTransferId}
        />
        <InvestorTransferNavSummaryTable
          fundFamilyId={fundFamilyId}
          investorTransferId={investorTransferId}
        />
        <InvestorTransferReviewDocumentsTable
          fundFamilyId={fundFamilyId}
          investorTransferId={investorTransferId}
        />
      </PageBody>
    </PageContent>
  );
};
